import { render, staticRenderFns } from "./visits-visitors-contacts-avg.vue?vue&type=template&id=146bd926&scoped=true&lang=pug&"
import script from "./visits-visitors-contacts-avg.vue?vue&type=script&lang=ts&"
export * from "./visits-visitors-contacts-avg.vue?vue&type=script&lang=ts&"
import style0 from "./visits-visitors-contacts-avg.vue?vue&type=style&index=0&id=146bd926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146bd926",
  null
  
)

export default component.exports